import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

export const TRANSFORMER = graphql.transformers.OUT.enumeration<
  graphql.schema.RateReportPurpose,
  ents.extra.rate.Report.Purpose
>({
  [graphql.schema.RateReportPurpose.Proposal]:
    ents.extra.rate.Report.Purpose.Proposal,
  [graphql.schema.RateReportPurpose.Qa]: ents.extra.rate.Report.Purpose.Qa,
})
